import React, { Component } from 'react'
import BillItem from '../BillItem'
import { inject, observer } from 'mobx-react'

@inject('detailStore')
@observer
export default class extends Component {
  render() {
    const { orderDetail } = this.props.detailStore
    const { brokerageOrders } = orderDetail

    return (brokerageOrders || []).map((item, index) => {
      return <BillItem key={item.id} item={item} index={index} />
    })
  }
}
